import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-flex-row p-jc-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_FunctionCatalogInputColumn = _resolveComponent("FunctionCatalogInputColumn")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.functionsCatalog.inputColumns')), 1)
        ]),
        end: _withCtx(() => [
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "kn-button p-button-text",
                label: _ctx.$t('managers.functionsCatalog.addColumn'),
                onClick: _ctx.addInputColumn
              }, null, 8, ["label", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      (_ctx.inputColumns.length === 0)
        ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('managers.functionsCatalog.noInputColumnsRequired')), 1))
        : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.inputColumns, (inputColumn, index) => {
            return (_openBlock(), _createBlock(_component_FunctionCatalogInputColumn, {
              key: index,
              column: inputColumn,
              readonly: _ctx.readonly,
              onDeleted: ($event: any) => (_ctx.deleteInputColumn(index))
            }, null, 8, ["column", "readonly", "onDeleted"]))
          }), 128))
    ]),
    _: 1
  }))
}